module.exports = __webpack_public_path__ + "static/media/tie.de37bc21.mp3";